import { render } from "./OrganisationCoinStatus.vue?vue&type=template&id=20cc6590"
import script from "./OrganisationCoinStatus.vue?vue&type=script&lang=js"
export * from "./OrganisationCoinStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__